module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/level-green-low-efdb055ef3f9534d01c4404d7ac3bff0.svg";